export default "__VITE_ASSET__DZUfFFK0__"